import React, { useEffect } from "react";
import PropTypes from "prop-types";

import Button from "@material-ui/core/Button";

const FacebookLogin = ({
	appId,
	xfbml = true,
	cookie,
	version,
	scope,
	returnScopes,
	auth_type,
	onFailure,
	callback,
	button_name,
	language,
	...props
}) => {
	const loadSdkAsynchronously = () => {
		((d, s, id) => {
			const element = d.getElementsByTagName(s)[0];
			const fjs = element;
			let js = element;
			if (d.getElementById(id)) {
				return;
			}
			js = d.createElement(s);
			js.id = id;
			js.src = `https://connect.facebook.net/${language}/sdk.js`;
			fjs.parentNode.insertBefore(js, fjs);
		})(document, "script", "facebook-jssdk");
	};

	useEffect(() => {
		loadSdkAsynchronously();
		window.fbAsyncInit = () => {
			window.FB.init({
				version: `v${version}`,
				appId,
				xfbml,
				cookie,
			});
		};
	}, []);

	const getLoginStatus = () => {
		// Reference: https://developers.facebook.com/docs/reference/javascript/FB.getLoginStatus
		// Use `true` as second argument to not use cached version
		// because we want fresh token and not the cached version that can sometimes throw
		// error in our GraphQL when actually requesting for public_profile info if user
		// recently logged out of facebook
		window.FB.getLoginStatus((response) => {
			switch (response.status) {
				case "connected":
					callback(response.authResponse);
					break;
				default:
					login();
			}
		}, true);
	};

	const login = () => {
		try {
			window.FB.login(
				(response) => {
					if (!response.authResponse) {
						switch (response.status?.toLowerCase()) {
							case "unknown":
								return onFailure(
									new Error("Failed to retrieve email address."),
								);
							default:
								return onFailure(new Error(response.status));
						}
					}
					return callback(response.authResponse);
				},
				{ scope, returnScopes, auth_type },
			);
		} catch (err) {
			console.error(err);
		}
	};

	const loginOnClickHandler = () => {
		if (!window.FB) return console.error("facebook sdk not loaded");
		getLoginStatus();
	};

	return (
		<React.Fragment>
			<Button {...props} onClick={loginOnClickHandler}>
				{button_name ? button_name : "Sign up with Facebook"}
			</Button>
			<div id={"fb-root"} />
		</React.Fragment>
	);
};

FacebookLogin.propTypes = {
	appId: PropTypes.string.isRequired,
};

FacebookLogin.defaultProps = {
	xfbml: true,
	cookie: true,
	store: "true",
	version: "20.0",
	language: "en_US",
	scope: "email public_profile",
	return_scopes: "true",
	auth_type: "",
	fields: "",
};

export default FacebookLogin;
